import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

// ── Thunks ──────────────────────────────────────────────────
export const get_campaigns = createAsyncThunk(
    'campaign/list',
    async (
        { page = 1, limit = 12, status = '', include = '', itemLimit = 0 } = {},
        { fulfillWithValue, rejectWithValue }
    ) => {
        try {
            const params = new URLSearchParams()
            params.set('page', page)
            params.set('limit', limit)
            if (status) params.set('status', status)
            if (include) params.set('include', include)
            if (itemLimit > 0) params.set('itemLimit', String(itemLimit))
            const { data } = await api.get(`/campaigns?${params.toString()}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: error.message })
        }
    }
)

export const get_campaign_detail = createAsyncThunk(
    'campaign/detail',
    async (slug, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/campaign/${encodeURIComponent(slug)}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: error.message })
        }
    }
)

// ── Slice ───────────────────────────────────────────────────
const campaignSlice = createSlice({
    name: 'campaign',
    initialState: {
        campaigns:       [],
        total:           0,
        page:            1,
        totalPages:      1,
        currentCampaign: null,
        loader:          false,
        detailLoader:    false,
        successMessage:  '',
        errorMessage:    '',
    },
    reducers: {
        messageClear:  (s) => { s.successMessage = ''; s.errorMessage = '' },
        clearCampaign: (s) => { s.currentCampaign = null },
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_campaigns.pending,   (s) => { s.loader = true })
            .addCase(get_campaigns.fulfilled, (s, { payload }) => {
                s.loader = false
                s.campaigns = payload.campaigns || []
                s.total = payload.total || 0
                s.page = payload.page || 1
                s.totalPages = payload.totalPages || 1
            })
            .addCase(get_campaigns.rejected,  (s) => { s.loader = false })

            .addCase(get_campaign_detail.pending,   (s) => { s.detailLoader = true })
            .addCase(get_campaign_detail.fulfilled, (s, { payload }) => {
                s.detailLoader = false
                s.currentCampaign = payload.campaign || null
            })
            .addCase(get_campaign_detail.rejected,  (s, { payload }) => {
                s.detailLoader = false
                s.errorMessage = payload?.error || payload?.message || 'Kampaniya tapılmadı'
            })
    },
})

export const { messageClear, clearCampaign } = campaignSlice.actions
export default campaignSlice.reducer
